import { gql } from '@efficiently/client-core-graphql-models';

/**
 * Soft-deletes one markup and returns its id.
 *
 * Sequence numbers of the surviving markups are **not** renumbered (Markup contract §4).
 */
export const DELETE_MARKUP = gql(`
	mutation DeleteMarkup($id: ID!) {
		deleteMarkup(id: $id)
	}
`);
